import React from "react";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";

//@SCSS
import "./changeSummary.scss";

import type { RootState } from "../../../../../store";

// @ICONS
import { ReactComponent as CloserIcon } from "../../../../../assets/images/close-square2.svg";
import { ReactComponent as InfoCircle } from "../../../../../assets/images/info-circle.svg";

// @Hooks
import usePlaceOrder from "../../../../../hooks/api/get/getPlaceOrder";

// @Components
import RectangleSleton from "../../../../../components/Alerts/common/RectangleSkeltion";
import useOrderMargin from "../../../../../hooks/api/get/getOrderMargin";
import {
  getCumulativeCharges,
  getTurnOver,
} from "./utils";

interface CloseChargedSumaryModalProps {
  onClose: () => void;
}

const ChargedSumary: React.FC<CloseChargedSumaryModalProps> = ({ onClose }) => {
  const isSummaryWindowOpen = useSelector(
    (state: RootState) => state.orders.chargesSummaryVisible
  );

  const orderSummary = useSelector(
    (state: RootState) => state.orders.orderSummary
  );

  const {
    data: marginData,
    error,
    loading,
  } = useOrderMargin({
    stockExchnage: orderSummary.stockExchnage,
    mktinstrumentType: orderSummary.mktinstrumentType,
    marketSegmentId: orderSummary.marketSegmentId!,
    tradeType: orderSummary.tradeType!,
    transactionType: orderSummary.transactionType!,
    price: orderSummary.price!,
  });

  // const getTurnOver
  const turnOver = getTurnOver({
    orderPrice: orderSummary.price!,
    totalQuantity: isSummaryWindowOpen.quantity!,
    lotSize: orderSummary.lotSize!,
  });


  const chargesSummary = marginData
    ? getCumulativeCharges(marginData, turnOver, isSummaryWindowOpen.quantity)
    : [];

  const isModalOpen = Boolean(isSummaryWindowOpen);

  if (!isModalOpen) {
    return null;
  }

  return (
    <Draggable handle=".handle_b" bounds="parent" allowAnyClick>
      <div
        style={{ maxWidth: "483px" }}
        className="custom-order-dialog_basket currentBg text-color"
      >
        <div
          style={{ height: 80 }}
          className="container optionStartegyHead handle_b charge-summary-bakground"
        >
          <div className="font-18 fw-bold text-white-gray">Charge Summary</div>

          {/* Close Modal Button */}
          <div className="d-flex c-pointer no-drag" onClick={onClose}>
            <CloserIcon />
          </div>
        </div>
        <div className="px-4">
          <table className="px-2 w-100 my-2">
            <tbody className="">

              {chargesSummary.map(({ label, value }, index) => {
                return (
                  <tr className="mx-4" key={index}>
                    <td
                      className={`w-75 font-12 p-1 text-start ${
                        index === chargesSummary.length - 1 ? "fw-bold" : ""
                      }`}
                    >
                      {label}
                    </td>
                    <SummaryLoader
                      value={value}
                      isError={!!error}
                      isLoading={loading}
                      toFixed={index === 0 ? 2 : 4}
                    />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div
          style={{ height: 60, opacity: 0.7 }}
          className="px-3 font-12 text-start text-color alerts-create-edit-background border-0 d-flex justify-content-between  py-2"
        >
          <span>
            <InfoCircle height={12} />
          </span>
          Information in Transaction Estimator is approximate, not the actual.
          Refer to the contact note emailed for exact prices, fees, and changes
          for trades executed.
        </div>
      </div>
    </Draggable>
  );
};

export default ChargedSumary;

const SummaryLoader = ({
  value,
  isError,
  isLoading,
  toFixed,
}: {
  value?: number;
  isError: boolean;
  isLoading: boolean;
  toFixed?: number;
}): JSX.Element => {
  if (isError) {
    // If there's an error, show an error message
    return <td className="w-25 font-12 fw-bold p-1 text-end">- -</td>;
  }

  // If value is defined, display it with 4 decimal places
  if (value !== undefined) {
    return (
      <td className="w-25 font-12 fw-bold p-1 text-end">
        {"₹ " + value.toFixed(toFixed)}
      </td>
    );
  }

  if (isLoading) {
    return (
      <td className="w-25 font-12 fw-bold p-1 text-end">
        <RectangleSleton style={{ width: "100px", height: "8px" }} />
      </td>
    );
  }

  return <td className="w-25 font-12 fw-bold p-1 text-end">- -</td>;
};
